import {Content} from "#/src/pages/live/@id/Content";
import {LiveStreamersHeader} from "#/src/components/LiveStreamersHeader";
import {EmbedContent} from "#/src/pages/live/@id/EmbedContent";

export {Page}

function Page() {
  return <>
    <div id={"liveView"}>
      <LiveStreamersHeader/>
      <EmbedContent/>
    </div>
    <Content/>
  </>
}
